import script from "./SpouseConnector.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpouseConnector.vue?vue&type=script&lang=ts&setup=true"

import "./SpouseConnector.vue?vue&type=style&index=0&id=fa736c66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa736c66"]])

export default __exports__